/**
 * @param {object} props
 * @param {React.ReactNode} pros.children
 * @param {React.ReactNode} props.heading
 * @param {React.ReactNode} props.subheading
 * @param {React.ReactNode} [props.comment]
 * @param {string} [props.className]
 * @returns {React.Component}
 */
export default function InfoCard({
  children,
  heading,
  subheading,
  comment,
  className,
}) {
  return (
    <div
      className={`flex bg-c-gray-600 rounded-lg p-2 col-span-1 ${className}`}
    >
      {children ? (
        children
      ) : (
        <div className="flex flex-col justify-between">
          <h3>{comment}</h3>
          <h2>{heading}</h2>
          <p className="text-c-gray-400">{subheading}</p>
        </div>
      )}
    </div>
  );
}
